"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _WarningYellowOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/WarningYellowOutline"));

var _messageBox = _interopRequireDefault(require("../../messageBox"));

var _context2 = require("../context");

var _hooks = require("../hooks");

var _utils = require("../utils");

var _actions = require("../actions");

var _reducer = _interopRequireDefault(require("../reducer"));

var _Table = _interopRequireDefault(require("./Table"));

require("./style.css");

var _excluded = ["children", "defaultSelectedRows", "defaultExpandedRows", "expandedRows", "columnsDef"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context3, _context4; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(source), !0)).call(_context3, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var TableProvider = function TableProvider(_ref) {
  var _context;

  var children = _ref.children,
      defaultSelectedRows = _ref.defaultSelectedRows,
      defaultExpandedRows = _ref.defaultExpandedRows,
      expandedRows = _ref.expandedRows,
      columnsDef = _ref.columnsDef,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useColumnsFromColumn = (0, _hooks.useColumnsFromColumnsDef)(columnsDef, props.responsive),
      columns = _useColumnsFromColumn.columns,
      maxHeaderCount = _useColumnsFromColumn.maxHeaderCount;

  var exportableColumnKeys = (0, _map["default"])(_context = (0, _filter["default"])(columns).call(columns, function (column) {
    return typeof column.exportable === "undefined";
  })).call(_context, function (column) {
    return column.key;
  });

  var _useReducer = (0, _react.useReducer)(_reducer["default"], _objectSpread(_objectSpread({}, props), {}, {
    columns: (0, _utils.hydradeColumnsFromLocalStorage)(columns, props.tableId, props.enablePersistConfig),
    exportableColumnKeys: exportableColumnKeys,
    maxHeaderCount: maxHeaderCount,
    isInitialWidthSet: false,
    tableWidth: 0,
    sortBy: null,
    sortOrder: null,
    allRowsSelected: false,
    selectedRow: null,
    selectedRows: defaultSelectedRows || [],
    controlSelection: !!props.selectedRows,
    expandedRows: expandedRows || defaultExpandedRows || [],
    controlExpansion: !!expandedRows,
    isLoadingMore: props.isLoadingMore
  })),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var fireAction = (0, _react.useCallback)(function (action) {
    return dispatch(action);
  }, []);

  var value = _objectSpread(_objectSpread({}, state), {}, {
    fireAction: fireAction
  });

  (0, _hooks.useRowSelect)(value, props);
  (0, _hooks.useUpdateContextOnPropChanges)(fireAction, props, value);
  var deriveColumnsFromProps = (0, _react.useCallback)(function (newColumns, oldColumns) {
    return (0, _map["default"])(oldColumns).call(oldColumns, function (column) {
      var key = column.key;
      var respectiveNewColumn = (0, _find["default"])(newColumns).call(newColumns, function (c) {
        return c.key === key;
      });

      if (respectiveNewColumn) {
        var width = column.width,
            hidden = column.hidden,
            frozen = column.frozen;
        return _objectSpread(_objectSpread({}, respectiveNewColumn), {}, {
          width: width,
          hidden: hidden,
          frozen: frozen,
          timestamp: (0, _now["default"])() // To fix https://github.com/Autodesk/react-base-table/issues/111

        });
      }

      return column;
    });
  }, []);
  (0, _react.useEffect)(function () {
    fireAction((0, _actions.updateStateValues)({
      columns: deriveColumnsFromProps(columns, value.columns)
    }));
  }, [fireAction, columns]);
  (0, _react.useEffect)(function () {
    (0, _utils.storeTableConfigInLocalStorage)(props.tableId, props.enablePersistConfig, value.columns);
  }, [value.columns, props.tableId, props.enablePersistConfig]);
  return /*#__PURE__*/_react["default"].createElement(_context2.Provider, {
    value: value
  }, children || /*#__PURE__*/_react["default"].createElement(_Table["default"], null));
};

TableProvider.propTypes = {
  /**
   * Unique Table ID (Very useful in case of multiple tables on same page).
   */
  tableId: _propTypes["default"].string,

  /**
   * Children of the table provider which will be exported compound components.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),

  /**
   * Array of column objects.
   */
  columnsDef: _propTypes["default"].array.isRequired,

  /**
   * Array of data items for each row. They should contain unique id.
   */
  data: _propTypes["default"].array.isRequired,

  /**
   * This key will be used to identify rows in a dataset. Default is `id`.
   */
  uniqueDataKey: _propTypes["default"].string,

  /**
   * Width of the table. Ideally it shouldn't be provided as we're using AutoSizer.
   */
  width: _propTypes["default"].number,

  /**
   * Height of the table in pixels.
   */
  height: _propTypes["default"].number,

  /**
   * Whether the table should be responsive. If true, all columns will be visible.
   */
  responsive: _propTypes["default"].bool,

  /**
   * A boolean flag to hide the table headers.
   */
  hideHeader: _propTypes["default"].bool,

  /**
   * Whether we want the checkbox/radio column to be sticky to left side.
   */
  fixSelectionColumn: _propTypes["default"].bool,

  /**
   * A boolean flag to indicate the table rows might be expandable
   */
  isExpandable: _propTypes["default"].bool,

  /**
   * A boolean flag to indicate the table is selectable with checkbox/radio.
   */
  isSelectable: _propTypes["default"].bool,

  /**
   * A boolean flag to indicate multiple rows can be selected in the table.
   */
  multiSelect: _propTypes["default"].bool,

  /**
   * An array of unique IDs whose rows will be disabled to be checked.
   */
  disabledRows: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),

  /**
   * An array of initially checked row IDs.
   */
  defaultSelectedRows: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),

  /**
   * An array of selected row IDs. Only provide if selection is maintained outside of the table.
   */
  selectedRows: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),

  /**
   * An array of initially expanded row IDs.
   */
  defaultExpandedRows: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),

  /**
   * An array of expanded row IDs.
   */
  expandedRows: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),

  /**
   * A boolean flag to render loading overlay over the entire table.
   */
  isLoading: _propTypes["default"].bool,

  /**
   * A boolean flag to render load more loader on bottom of the table.
   */
  isLoadingMore: _propTypes["default"].bool,

  /**
   * A text string to be rendered before load more spinner.
   */
  loadingMoreText: _propTypes["default"].string,

  /**
   * A boolean flag to tell all records have been loaded. So scroll down will not be triggered.
   */
  loadedAll: _propTypes["default"].bool,

  /**
   * If footerRenderer is provided, this is required. Default is 40.
   */
  footerHeight: _propTypes["default"].number,

  /**
   * A callback handler to be called on click of select all checkbox.
   */
  onSelectAll: _propTypes["default"].func,

  /**
   * An estimated height of each row to prevent flickering as much as possible
   */
  estimatedRowHeight: _propTypes["default"].number,

  /**
   * A callback handler to be called on click of any row.
   */
  onRowClick: _propTypes["default"].func,

  /**
   * A function to be called while rendering the checkbox/radio to get the tooltip for it.
   */
  getSelectionInputTooltip: _propTypes["default"].func,

  /**
   * A function to be called while rendering rows to get their class names from the consumer.
   */
  getRowClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),

  /**
   * A callback to be called when the table selection is changed (checked/unchecked any row).
   */
  onRowSelectionChange: _propTypes["default"].func,

  /**
   * A callback to be called when the scroll reaches to the bottom of the table.
   */
  onLoadMore: _propTypes["default"].func,

  /**
   * A callback to be called when click on row expand icon.
   */
  onRowExpand: _propTypes["default"].func,

  /**
   * A custom row renderer which is useful when we want to render some details of a parent row.
   */
  rowRenderer: _propTypes["default"].func,

  /**
   * A callback to be called when there is no data available to the table.
   */
  emptyRenderer: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),

  /**
   * A function to be called when footer is required to be rendered at below the table.
   */
  footerRenderer: _propTypes["default"].func,

  /**
   * Enable/Disable table configuration button
   */
  enableConfiguration: _propTypes["default"].bool,

  /**
   * Enable/Disable full screen feature
   */
  enableFullScreen: _propTypes["default"].bool,

  /**
   * Enable/Disable export to csv feature
   */
  enableExportToCsv: _propTypes["default"].bool,

  /**
   * CSV File name if enableExportToCsv is true
   */
  csvFileName: _propTypes["default"].string,

  /**
   * Column name for data is default sorted by
   */
  sortBy: _propTypes["default"].string,

  /**
   * Default sorting order of column specified in sortBy
   */
  sortOrder: _propTypes["default"].oneOf(["asc", "desc"]),

  /**
   * On column sort handler
   */
  onSort: _propTypes["default"].func,

  /**
   * Globally control resizable
   */
  resizable: _propTypes["default"].bool,

  /**
   * Max height for export to csv popup columns container
   */
  exportPopupMaxHeight: _propTypes["default"].number,

  /**
   * Enable/Disable row split feature
   */
  enableRowSpan: _propTypes["default"].bool,

  /**
   * Enable table config persist feature
   */
  enablePersistConfig: _propTypes["default"].bool,

  /**
   * Enable table config persist feature
   */
  enableCSVToastMessage: _propTypes["default"].bool
};
TableProvider.defaultProps = {
  tableId: "data-grid",
  responsive: false,
  height: 400,
  uniqueDataKey: "id",
  hideHeader: false,
  fixSelectionColumn: false,
  isSelectable: false,
  multiSelect: true,
  disabledRows: [],
  isLoading: false,
  loadingMoreText: "Loading More Rows...",
  loadedAll: false,
  footerHeight: 40,
  estimatedRowHeight: 40,
  enableConfiguration: false,
  enableFullScreen: false,
  enableExportToCsv: false,
  csvFileName: "data-grid",
  enableCSVToastMessage: false,
  emptyRenderer: function emptyRenderer() {
    return /*#__PURE__*/_react["default"].createElement(_messageBox["default"], {
      isHtml: true,
      icon: /*#__PURE__*/_react["default"].createElement(_WarningYellowOutline["default"], {
        width: 56,
        height: 56
      }),
      primaryText: "Error loading data",
      secondaryText: "We are facing issues while loading. <br/>Please retry again later"
    });
  },
  exportPopupMaxHeight: 250,
  enableRowSpan: false,
  enablePersistConfig: false
};
var _default = TableProvider;
exports["default"] = _default;